import { useAuthAppStore } from "@/store/stores/authStore";

export class CurrencyService {
  async getCurrencyConversion({ cproxServiceClient, params }) {
    var response = await cproxServiceClient.currency.get({
      route: "xe/get-all-conversions",
      params: { ...params },
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: (resp) => {
        console.log("resp", resp);
        
        return resp
      },
      errorCallback: (error) => {
        console.error("Departman verisi alınırken hata oluştu:", error);
        return []; // Hata durumunda boş dizi dönüyoruz
      },
    });

    return response;

  }

  async findCurrencyRate({ cproxServiceClient, params }) {
    var response = await cproxServiceClient.currency.post({
      route: "xe/find-currency-rate",
      params: { ...params },
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: (resp) => {
        console.log("resp", resp);
        
        return resp
      },
      errorCallback: (error) => {
        console.error("Veri alınırken hata olustu:", error);
        return []; // Hata durumunda boş dizi dönüyoruz
      },
    });

    return response;

  }

}
